import { createSlice } from "@reduxjs/toolkit";

export const bidSlice = createSlice({
    name: "sheet",
    initialState: {
        updating: false,
        openCommentKey: null,
        openComments: false,
        focusedCommentKey: null,
        highlights: [],
    },
    reducers: {
        setUpdating: (state, action) => {
            state.updating = action.payload;
        },
        setOpenCommentKey: (state, action) => {
            state.openCommentKey = action.payload;
        },
        setOpenComments: (state, action) => {
            state.openComments = action.payload;
        },
        setFocusedCommentKey: (state, action) => {
            state.focusedCommentKey = action.payload;
        },
        setHighlights: (state, action) => {
            state.highlights = action.payload;
        },
        setSelectedCellCommentKey: (state, action) => {
            state.selectedCellCommentKey = action.payload;
        },
    },
});

export const {
    setUpdating,
    setOpenCommentKey,
    setOpenComments,
    setFocusedCommentKey,
    setHighlights,
    setSelectedCellCommentKey,
} = bidSlice.actions;

export const selectIsUpdating = (state) => state.sheet.updating;
export const selectOpenCommentKey = (state) => state.sheet.openCommentKey;
export const selectOpenComments = (state) => state.sheet.openComments;
export const selectFocusedCommentKey = (state) => state.sheet.focusedCommentKey;
export const selectHighlights = (state) => state.sheet.highlights;
export const selectSelectedCellCommentKey = (state) =>
    state.sheet.selectedCellCommentKey;

export default bidSlice.reducer;
